import { Box, Skeleton } from '@mui/material';

import { LoanValue } from '@components/overviewPanels/existingLoanPanel/ExistingLoanPanel';
import LegendEntry from '@components/overviewPanels/existingLoanPanel/LegendEntry';

interface LegendProps {
    loans: LoanValue[];
    colors: string[];
    currencyCode: string;
    isLoading?: boolean;
    legendValuesNotPlotted?: LoanValue[];
}

const Legend = ({
    isLoading = false,
    legendValuesNotPlotted,
    loans,
    colors,
    currencyCode,
}: LegendProps) => (
    <Box marginLeft={2.75}>
        {isLoading ? (
            <Box marginTop={5}>
                <Skeleton
                    data-testid="loan-loader-1"
                    width={85}
                    sx={{ mb: 3 }}
                />
                <Skeleton data-testid="loan-loader-2" width={85} />
            </Box>
        ) : (
            <Box marginTop={5}>
                {legendValuesNotPlotted?.map((loan) => (
                    <LegendEntry
                        key={`legend-entry-${loan?.id}`}
                        loan={loan}
                        currencyCode={currencyCode}
                    />
                ))}
                {loans.map((loan, index) => (
                    <LegendEntry
                        key={`legend-entry-${loan?.id}`}
                        loan={loan}
                        index={index}
                        colors={colors}
                        currencyCode={currencyCode}
                    />
                ))}
            </Box>
        )}
    </Box>
);

export default Legend;
